import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import {
  convertToCurrencyFormat,
  convertToTwoDecimals,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
  getSerialFromBarcode,
} from "../../../shared/utility";
import SelectMenu from "../../controls/SelectMenu";
import OrderSubtable1 from "./subtables/OrderSubtable1";

export default function OrderProductsTable(props) {
  const {
    loading,
    values,
    onItemEditComplete,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const allowExpansion = (rowData) => {
    return rowData.source_items.length > 0;
  };

  const rowExpansionTemplate = (rowData) => {
    return (
      <OrderSubtable1
        data={rowData.source_items}
        onItemEditComplete={onItemEditComplete}
      />
    );
  };

  const totalCostBody = (rowData) => {
    return <p>{convertToCurrencyFormat(rowData.total_cost)}</p>;
  };

  const barcodeBody = (rowData) => {
    return <p>{rowData.barcode}</p>;
  };

  const rowStyleClass = (data) => {
    if (data.credit_return_id > 0) {
      return { "bg-cyan-100": true };
    } else if (data.is_returned === 0) {
      return { "bg-gray-100": true };
    } else if (data.is_returned === 1) {
      return { "bg-yellow-100": true };
    }
    return {};
  };

  return (
    <div className="">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="overflow-hidden">
              <DataTable
                value={values.mixed_cartons}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                  setExpandedRows(e.data);
                }}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="id"
                tableClassName="min-w-full divide-y divide-gray-300 create-order-inventory-table-parent"
                cellClassName="p-2 border-1-bottom-gray text-sm"
                rowClassName={rowStyleClass}
                editMode="row"
              >
                <Column header="Barcode" body={barcodeBody} />
                <Column header="Shipped by" field="shipped_by_name" />

                <Column
                  header="Subtotal Price"
                  field="subtotal_amount"
                  style={{ textAlign: "right" }}
                  body={totalCostBody}
                />

                <Column expander={allowExpansion} style={{ width: "6%" }} />
              </DataTable>
            </div>
          )}
          <div className="mt-6 flex justify-end">
            <div className="w-full max-w-sm">
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium text-gray-600">Subtotal:</span>
                  <span className="text-md font-semibold text-gray-900">
                    {convertToCurrencyFormat(values.subtotal_dollar_amount)}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium text-gray-600">Tax:</span>
                  <span className="text-md font-semibold text-gray-900">$0.00</span>
                </div>
                <div className="border-t border-gray-300 pt-2 mt-2">
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold text-gray-900">Total:</span>
                    <span className="text-lg font-bold text-gray-900">
                      {convertToCurrencyFormat(values.total_dollar_amount)}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-gray-900">Total Cartons:</span>
                  <span className="text-lg font-bold text-gray-900">
                    {values.total_cartons} cartons
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
